import {Injectable} from '@angular/core';
import {TOOL, ToolTypes} from 'src/app/constants/map';

@Injectable({
    providedIn: 'root'
})
export class MapboxglCustomCompassControl {

    private container: any;
    public service: any;
    public button: HTMLButtonElement;
    private readonly clickHandler: () => void;
    private icon: any;

    constructor(
        {mapboxglService}
    ) {
        this.service = mapboxglService;
        this.clickHandler = this.handleClick.bind(this);
        this.service.controlOnLoadedSubject.subscribe(control => {
            if (control !== ToolTypes.custom_compass) {
                // Thêm logic xử lý nếu cần
            }
        });
    }

    handleClick = () => {
        // Xử lý sự kiện zoom in
        this.icon = this.button.querySelector<HTMLElement>('.material-icons-outlined');
        if (this.icon) {
            this.button.classList.add('active');
            this.icon.style.color = 'red';
            setTimeout(() => {
                this.icon.style.color = 'black';
                this.button.classList.remove('active');
            }, 100);
        }
        this.resetMapView().then();
    }

    eventClick(e: any): void {
        this.button = e.currentTarget;
        this.handleClick();
    }

    async resetMapView(): Promise<void> {
        const defaultMapView = {
            bounds: [[94.5693359375, 27.098739624023438], [95.49100494384766, 27.71263313293457]],
            center: [94.90903297, 27.4805688],
            zoom: 11,
            bearing: 0,
            pitch: 0
        };
        await this.service.map.flyTo({
            center: defaultMapView.center,
            zoom: defaultMapView.zoom,
            bearing: defaultMapView.bearing,
            pitch: defaultMapView.pitch,
            padding: 80,
            duration: 5000,
        });
    }

    onAdd(): void {
        const customCompassToolInfo: TOOL = {
            name: 'Compass',
            // iconClass: 'esri-icon esri-icon-compass',
            iconClass: 'material-icons-outlined',
            code: 'CUSTOM_COMPASS',
            active: false,
            className: 'explore',
        };

        const customCompassTool = this.service.utilityFn.createTool(customCompassToolInfo, this.eventClick.bind(this));
        this.container = this.service.utilityFn.createControl([customCompassTool], 'mapbox-gl-custom_compass');
        return this.container;
    }

    onRemove(): void {
        this.container.parentNode.removeChild(this.container);
        this.service.map = undefined;
    }
}
